import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

export const actions = {
  async editRegularAttendeeSettings ({ commit }, editRegular) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(
        api.regularAttendeeSettings.editRegularAttendeeSettings(),
        { ...editRegular })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Regular attendee type was submit successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Regular attendee type wasn\'t submit')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/regularAttendeeSettings.js